// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 846 ? "Flickity" : chunkId) + "." + {"442":"b08913dd31e7d1602b2a","846":"e7af5700f68507d5fc84"}[chunkId] + ".js";
};